import React from "react";
import { Layers as LayersIcon, Map as MapIcon, VisibilityOff as VisibilityOffIcon } from "@mui/icons-material";
import { ToggleButtonGroup, Tooltip } from "@mui/material";

import { LayerVisibility } from "./visibility";

import { StyledToggleButton } from "./LayerVisibilityToggle.styles";

interface LayerVisibilityToggleProps {
  value: LayerVisibility;
  onChange: (value: LayerVisibility) => void;
}

export const LAYER_VISIBILITY_LABELS: Record<LayerVisibility, string> = {
  hidden: "Don't show on grid map or key map",
  grid: "Show on grid map",
  both: "Show on grid map and key map",
};

const OPTIONS: ReadonlyArray<{ value: LayerVisibility; icon: React.ReactNode }> = [
  { value: "hidden", icon: <VisibilityOffIcon fontSize="inherit" /> },
  { value: "grid", icon: <MapIcon fontSize="inherit" /> },
  { value: "both", icon: <LayersIcon fontSize="inherit" /> },
];

const LayerVisibilityToggle: React.FC<LayerVisibilityToggleProps> = ({ value, onChange }) => {
  return (
    <ToggleButtonGroup
      size="small"
      exclusive
      value={value}
      onChange={(_, next: LayerVisibility | null) => {
        if (next !== null) onChange(next);
      }}
      sx={{ ml: 1 }}
    >
      {OPTIONS.map((option) => {
        const label = LAYER_VISIBILITY_LABELS[option.value];
        return (
          <Tooltip key={option.value} title={label}>
            <StyledToggleButton value={option.value} aria-label={label} data-testid={`layer-visibility-${option.value}`}>
              {option.icon}
            </StyledToggleButton>
          </Tooltip>
        );
      })}
    </ToggleButtonGroup>
  );
};

export default LayerVisibilityToggle;
